var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7279 10.0204C12.7279 10.794 12.1001 11.4218 11.3265 11.4218C10.553 11.4218 9.92515 10.794 9.92515 10.0204C9.92515 9.24687 10.553 8.61907 11.3265 8.61907C12.1001 8.61907 12.7279 9.24687 12.7279 10.0204ZM15.9977 8.61907C15.2242 8.61907 14.5964 9.24687 14.5964 10.0204C14.5964 10.794 15.2242 11.4218 15.9977 11.4218C16.7713 11.4218 17.3991 10.794 17.3991 10.0204C17.3991 9.24687 16.7713 8.61907 15.9977 8.61907ZM6.65531 8.61907C5.88176 8.61907 5.25395 9.24687 5.25395 10.0204C5.25395 10.794 5.88176 11.4218 6.65531 11.4218C7.42886 11.4218 8.05667 10.794 8.05667 10.0204C8.05667 9.24687 7.42886 8.61907 6.65531 8.61907ZM22.5374 3.94786V15.1587C22.5374 17.2197 20.8614 18.8957 18.8004 18.8957H16.136L12.541 21.8666C12.2038 22.1674 11.7712 22.3188 11.334 22.3188C10.8893 22.3188 10.4418 22.1618 10.0849 21.8451L6.58244 18.8957H3.85166C1.79072 18.8957 0.114696 17.2197 0.114696 15.1587V3.94786C0.11563 1.88693 1.79166 0.210901 3.85259 0.210901H18.8004C20.8614 0.210901 22.5374 1.88693 22.5374 3.94786ZM20.6689 3.94786C20.6689 2.9174 19.8309 2.07938 18.8004 2.07938H3.85259C2.82212 2.07938 1.98411 2.9174 1.98411 3.94786V15.1587C1.98411 16.1892 2.82212 17.0272 3.85259 17.0272H6.92437C7.14392 17.0272 7.35786 17.1048 7.52696 17.2468L11.3088 20.4325L15.2055 17.2412C15.3727 17.1029 15.5829 17.0272 15.8006 17.0272H18.8014C19.8318 17.0272 20.6699 16.1892 20.6699 15.1587L20.6689 3.94786Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_19"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.4218,
    height: 22.4218,
    fill: "white",
    transform: "translate(0.115646 0.210907)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIconWhite);
export default __webpack_public_path__ + "static/media/message_icon_white.67501983c2ad1d3335eec87428df05b7.svg";
export { ForwardRef as ReactComponent };